module.exports = __webpack_public_path__ + "img/cimb-3d-conquest.73993808.png";